import {
    apiRequest,
    processInput
} from "@/utilities"

export const nurseLicenseService = {
    async getNurseLicenses() {
        const getNurseLicensesRequest = {
            method: "GET"
        }
        return await apiRequest("/api/nurse-licenses", getNurseLicensesRequest)
    },
    async getNurseLicense(uuid) {
        const getNurseLicenseRequest = {
            method: "GET"
        }
        return await apiRequest(`/api/nurse-licenses/${uuid}`, getNurseLicenseRequest)
    },
    async createNurseLicense(params) {
        const createNurseLicenseRequest = {
            method: "POST",
            data: processInput(params)
        }
        return await apiRequest("/api/nurse-licenses", createNurseLicenseRequest)
    },
    async editNurseLicense(params) {
        const { uuid } = params;
        delete params.uuid
        let data = processInput(params)
        data.append("_method", "PATCH")
        const editNurseLicenseRequest = {
            method: "POST",
            data
        }
        return await apiRequest(`/api/nurse-licenses/${uuid}`, editNurseLicenseRequest)
    },
    async deleteNurseLicense(uuid) {
        const deleteNurseLicenseRequest = {
            method: "DELETE"
        }
        return await apiRequest(`/api/nurse-licenses/${uuid}`, deleteNurseLicenseRequest)
    }
}